import { LinkBroken02, Trash04 } from '@aktiia/design-system';
import { useCallback } from 'react';
import { useTranslation } from 'react-i18next';

import { ModalName } from '../../../../../../../../enums';
import { useOpenModal } from '../../../../../../../../features/modals';
import { IDeviceMenuPopoverProps } from './types';

export const DeviceMenuPopover = ({ device }: IDeviceMenuPopoverProps) => {
  const { t } = useTranslation();
  const openRemoveDeviceModal = useOpenModal(ModalName.REMOVE_DEVICE);

  const handleOnClick = useCallback(() => {
    openRemoveDeviceModal({ device });
  }, [openRemoveDeviceModal]);

  return (
    <div
      className="flex items-center bg-background-surface-primary hover:bg-global-zurich-10 px-4 h-[40px] w-[220px] rounded-xl shadow-high cursor-pointer"
      onClick={handleOnClick}
    >
      <span className="typography-title-3 text-text-primary">
        {t(`organization.devices.button.${device.canUnpair ? 'unpair' : 'remove'}`)}
      </span>
      <div className="grow" />
      {device.canUnpair ? <LinkBroken02 className="text-text-secondary" /> : <Trash04 className="text-text-negative" />}
    </div>
  );
};
